import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Flag, Clock, CheckCircle } from 'lucide-react';

export default function PriorityManagementTab({ stats }) {
  return (
    <div data-testid="priority-management-tab">
      <h1 className="text-3xl font-bold text-slate-900 mb-6">Priority Management</h1>
      <div className="grid grid-cols-3 gap-6">
        <Card className="border-red-200 bg-red-50">
          <CardHeader><CardTitle className="flex items-center gap-2 text-red-700"><Flag className="w-5 h-5" />High Priority</CardTitle></CardHeader>
          <CardContent>
            <p className="text-4xl font-bold text-red-700">{stats?.high_priority_cases || 0}</p>
            <p className="text-sm text-red-600">Cases requiring immediate attention</p>
          </CardContent>
        </Card>
        <Card className="border-amber-200 bg-amber-50">
          <CardHeader><CardTitle className="flex items-center gap-2 text-amber-700"><Clock className="w-5 h-5" />Medium Priority</CardTitle></CardHeader>
          <CardContent>
            <p className="text-4xl font-bold text-amber-700">{stats?.medium_priority_cases || Math.floor((stats?.pending_cases || 0) * 0.4)}</p>
            <p className="text-sm text-amber-600">Standard processing queue</p>
          </CardContent>
        </Card>
        <Card className="border-green-200 bg-green-50">
          <CardHeader><CardTitle className="flex items-center gap-2 text-green-700"><CheckCircle className="w-5 h-5" />Low Priority</CardTitle></CardHeader>
          <CardContent>
            <p className="text-4xl font-bold text-green-700">{stats?.low_priority_cases || Math.floor((stats?.pending_cases || 0) * 0.3)}</p>
            <p className="text-sm text-green-600">Flexible timeline cases</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
